export default "__VITE_ASSET__ef_4VNm2__"